import type { APIClient } from '../api';
import { queryClient } from '.';
import type { BuildQueryDescriptorParams } from './utils';
import { buildQueryDescriptor } from './utils';

export default function prefetchBaseQuery(
  url: string,
  client: APIClient,
  params?: BuildQueryDescriptorParams,
) {
  const { queryKey, queryFn, restParams } = buildQueryDescriptor(
    url,
    client,
    params,
  );

  return queryClient.prefetchQuery({ queryKey, queryFn, ...restParams });
}
